




















import { Component, Vue, Prop } from 'vue-property-decorator'
import PromotionOperate from './promotion_operate.vue'
import PromotionChoice from './promotion_choice.vue'
import PromotionPanicbuy from './promotion_panicbuy.vue'
import PromotionPanicbuyChoice from './promotion_panicbuy_choice.vue'
import HomeOperate from '../common/home_operate.vue'

@Component({
  components: {
    PromotionOperate,
    PromotionChoice,
    PromotionPanicbuy,
    PromotionPanicbuyChoice,
    HomeOperate
  }
})
export default class PromotionSection extends Vue {
  @Prop({ default: () => ({}) }) readonly panicbuy!: any //天天特价
  @Prop({ default: () => ({}) }) readonly choice!: any //超值精选
  @Prop({ default: () => [] }) readonly operate!: Array<any> //操作坑位配置列表
  @Prop({ default: () => false }) readonly isselfson!: boolean //是否展示新版同城亲子模板

  get showPromotion() {
    // let number = 0
    // const { promotionList: panicList = [] } = this.panicbuy || {}
    // const { promotionList: choiceList = [] } = this.choice || {}

    // number += panicList.length
    // number += choiceList.length
    // // if (this.isselfson) {
    // //   return false
    // // }

    // // if (number > 1) {
    // //   return true
    // // }
    // // return false
    // if (this.isselfson) {
    //   return false
    // } else if (number > 1) {
    //   return true
    // } else {
    //   return false
    // }
    //202212修改 去除老的天天特价
    return false
  }

  get showPromotionPanicbuyChoice() {
    // 天天特价+超值精选：天天特价/超值精选 中都有1个及以上的商品
    const { promotionList: panicList = [] } = this.panicbuy || {}
    const { promotionList: choiceList = [] } = this.choice || {}
    if (panicList.length > 0 && choiceList.length > 0) {
      return true
    }
    return false
  }

  get showPromotionPanicbuy() {
    // 天天特价：“天天特价” 中有2条及以上的商品，“超值精选”中无相关商品
    const { promotionList: panicList = [] } = this.panicbuy || {}
    const { promotionList: choiceList = [] } = this.choice || {}
    if (panicList.length > 1 && choiceList.length == 0) {
      return true
    }
    return false
  }

  get showPromotionChoice() {
    // 超值精选：“超值精选” 中有2条及以上的商品，“天天特价”中无相关商品
    const { promotionList: panicList = [] } = this.panicbuy || {}
    const { promotionList: choiceList = [] } = this.choice || {}
    if (panicList.length == 0 && choiceList.length > 1) {
      return true
    }
    return false
  }

  operateClick(item: any) {
    this.$emit('operateClick', item)
  }

  toPanicBuy(item: any) {
    this.$emit('toPanicBuy', item)
  }

  toChoice(item: any) {
    this.$emit('toChoice', item)
  }
}
